export default store => ({
  get hasError() {
    return store.errors.length > 0;
  },
});
